import { VehicleEquipmentFormula } from '../../../models/vehicle-equipment-formula';
import { FormulaWizardState } from '../formula-wizard.reducer';

export function getCurrentFormula(
  state: Pick<FormulaWizardState, 'formulaIndex' | 'formulas'>,
  newState?: FormulaWizardState
): VehicleEquipmentFormula {
  return (newState ?? state).formulas[state.formulaIndex];
}
